<template>
  <section>
    <b-table
      :data="data"
      :columns="columns"
      :debounce-search="1000">
    </b-table>
  </section>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          field: 'id',
          label: 'ID',
          width: '100',
          numeric: true,
          searchable: true,
        },
        {
          field: 'firstName',
          label: 'First Name',
          searchable: true,
        },
        {
          field: 'lastName',
          label: 'Last Name',
          searchable: true,
        },
        {
          field: 'date',
          label: 'Date',
          centered: true,
        },
        {
          field: 'community',
          label: 'Community',
        },
        {
          field: 'trigger',
          label: 'Trigger',
        },
        {
          field: 'action',
          label: 'Action',
        },
      ],
    };
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Workflows.vue